<div class="radio-wrapper">
  <div class="radio-container" [ngClass]="{ 'error': error }">
    <p-radiobutton
      [inputId]="inputId"
      [value]="value"
      [disabled]="disabled"
      [ngModel]="selectedValue"
      (ngModelChange)="onChange()"
      class="custom-radioButton"
      [ngClass]="size"
    ></p-radiobutton>
    @if (label) {
      <label [for]="inputId" class="custom-radioButton-label">{{ label }}</label>
    } @else if (value?.name) {
      <label [for]="inputId" class="custom-radioButton-label">{{ value.name }}</label>
    }
  </div>
  @if (helperText) {
    <span class="helper-text">{{ helperText }}</span>
  }
</div>
